var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
export class CallHistoryUIStore {
    // public loginstate:LoginStage  = LoginStage.LoggedOut;
    constructor() {
        this.callrecords = [];
        this.fetchedids = new Set();
        this.loadinghistory = false;
        this.loadinglatest = false;
        this.hasmore = true;
        makeObservable(this);
        // AEvent.addSubscriberForLoginStage((st) => {
        //     if(st === LoginStage.Loggedin) {
        //         this.loginstate = st;
        //         this.reset();
        //         this.hasmore = true;
        //         this.checkAndLoadRecents(true);
        //     }
        // });
        // AEvent.addSubscriberForAppstate((st) => {
        //     if(st == 'active' && this.loginstate ===LoginStage.Loggedin) {
        //         this.checkAndLoadRecents(false);
        //     }
        // })
        // AEvent.addSubscriberForCallEnded(() => {
        //     if(this.loginstate ===LoginStage.Loggedin) {
        //         this.checkAndLoadRecents(false);
        //     }
        // });
        APPEvent.addSubscriberForCallRecordRes((res) => {
            const append = res.append;
            if (append) {
                const logs = res.logs;
                if (logs.length > 0) {
                    logs.sort(this.sortLogs);
                    this.concatLogs(logs, true);
                }
                if (logs.length < 20) {
                    this.hasmore = false;
                }
                this.setLoadingHistory(false);
            }
            else {
                const logs = res.logs;
                if (logs.length > 0) {
                    this.concatLogs(logs, false);
                }
                this.setLoadingLatest(false);
            }
        });
    }
    setLoadingHistory(loading) {
        this.loadinghistory = loading;
    }
    setLoadingLatest(latest) {
        this.loadinglatest = latest;
    }
    concatLogs(logs, append = true) {
        logs = logs.filter((lg) => !this.fetchedids.has(lg.id))
            .sort(this.sortLogs).reverse()
            .map((lg) => {
            this.fetchedids.add(lg.id);
            return lg;
        });
        if (append) {
            this.callrecords = [...this.callrecords, ...logs];
        }
        else {
            this.callrecords = [...logs, ...this.callrecords];
        }
    }
    checkAndLoadRecents(inform) {
        if (this.callrecords.length > 0) {
            this.loadLatest(inform);
        }
        else {
            this.loadHistiory(inform);
        }
    }
    async loadLatest(inform = true) {
        if (this.loadinglatest) {
            return;
        }
        if (inform) {
            this.setLoadingLatest(true);
        }
        let loadtime = new Date().getTime();
        if (this.callrecords.length > 0) {
            loadtime = this.callrecords[0].time;
        }
        const req = {
            since: 0,
            after: loadtime,
            count: 20,
            ascending: true,
            type: undefined,
            append: false
        };
        Apphandler.sendMessage("fetchcalllogs", req);
    }
    sortLogs(l1, l2) {
        return l1.time - l2.time;
    }
    async loadHistiory(inform = true) {
        if (this.loadinghistory || !this.hasmore) {
            return;
        }
        if (inform) {
            this.setLoadingHistory(true);
        }
        let loadtime = new Date().getTime();
        if (this.callrecords.length > 0) {
            loadtime = this.callrecords[this.callrecords.length - 1].time;
        }
        const req = {
            since: loadtime,
            after: 0,
            count: 20,
            ascending: false,
            type: undefined,
            append: true,
        };
        Apphandler.sendMessage("fetchcalllogs", req);
        // const logs = await CallService.fetchCallLogs( loadtime,0, 20, false, undefined);
    }
    reset() {
        this.callrecords = [];
        this.fetchedids.clear();
        this.setLoadingHistory(false);
        this.setLoadingLatest(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], CallHistoryUIStore.prototype, "callrecords", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CallHistoryUIStore.prototype, "loadinghistory", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CallHistoryUIStore.prototype, "loadinglatest", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CallHistoryUIStore.prototype, "setLoadingHistory", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CallHistoryUIStore.prototype, "setLoadingLatest", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", void 0)
], CallHistoryUIStore.prototype, "concatLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CallHistoryUIStore.prototype, "reset", null);
